//https://regex101.com/r/FDJr2F/1
const camelCaseRegex = /((<=[a-z])[A-Z]|[A-Z](?=[a-z]))/g;
		
/**
* @ngdoc filter
* @name phoenix.filter:pxSpaceCamelCase
* @kind function
* 
* @description
*  Converts a camel cased string into spaces
*
* @param {string} camelCased A camel cased string.
* 
*/
export function SpaceCamelCaseFilter() {
	return function toSpaces(camelCased:string) {
		if(!camelCased){return camelCased;}
		camelCased = camelCased.replace(camelCaseRegex, ' $1');			

		return camelCased.trim();
	};
}


// WEBPACK FOOTER //
// ./src/phoenix/filters/camelCaseToSpace.ts